import React from 'react';
import mayin from '../img/mainu.jpg'
import './About.css'
const About = () => {
    return (
        <div>

            <div className="row justify-content-center">
                <div className="col-md-4 mt-3">

                    <img className='rounded-circle shadow bg-white p-1 m-3' style={{ width: '170px', height: '170px' }} src={mayin} alt="" />
                    <h5>MD. MAYIN UDDIN</h5>
                    <p>Frontend Designer</p>
                </div>
            </div>
            <br />
            <div className="row">
                <p className='about'>I am Mayin uddin..My Aim as a web developer and Software Developer also this my target.
                    A major motivation for a web designer is self-expression in being able to design and develop
                    a website to be proud of. Another goal is to make sure users of the website have a good experience.
                    Finally, a web designer hopes for career rewards, such as good pay and advancement..Finally i want to decided my
                    goal setup as a web Designer and Software Developer....
                </p>
            </div>



        </div>
    );
};

export default About;